import { dispatchHistory } from '../stores'
import { currentOrderUuid } from './orderNumbers'

import { isTestMode } from '../VNAndroidSDK/Utils'
import { getDeviceId, getDeviceSerial } from './deviceData'

export const createDataDogLog = (logType, message, additionalData = {}) => {
  const deviceSerial = getDeviceSerial() ?? 'NO_ID'
  const deviceId = getDeviceId() ?? 'NO_ID'
  const venueUuid = process?.env?.REACT_APP_VENUE_UUID
  const org = process?.env?.REACT_APP_ORG
  const sessionId = localStorage.getItem('sessionId')
  const activeOrderUuid = currentOrderUuid()

  if (['error', 'info', 'warn', 'debug'].includes(logType)) {
    window?.DD_LOGS?.logger?.[logType](message, {
      deviceId,
      deviceSerial,
      venueUuid,
      org,
      sessionId,
      activeOrderUuid,
      dispatchHistoryLastThree: dispatchHistory.slice(0, 3),
      ...additionalData,
    })
  }

  if (isTestMode()) {
    if (process.env.JEST_WORKER_ID !== undefined) return

    // eslint-disable-next-line no-console
    console[logType](`[${deviceId}] ${message}`, {
      deviceId,
      deviceSerial,
      venueUuid,
      org,
      sessionId,
      activeOrderUuid,
      dispatchHistoryLastThree: dispatchHistory.slice(0, 3),
      ...additionalData,
    })
  }
}

export const createDataDogLogNoHistory = (logType, message, additionalData = {}) => {
  const deviceSerial = getDeviceSerial() ?? 'NO_ID'
  const deviceId = getDeviceId() ?? 'NO_ID'
  const venueUuid = process?.env?.REACT_APP_VENUE_UUID
  const org = process?.env?.REACT_APP_ORG
  const sessionId = localStorage.getItem('sessionId')
  const activeOrderUuid = currentOrderUuid()

  if (['error', 'info', 'warn', 'debug'].includes(logType)) {
    window?.DD_LOGS?.logger?.[logType](message, {
      deviceId,
      deviceSerial,
      venueUuid,
      org,
      sessionId,
      activeOrderUuid,
      ...additionalData,
    })
  }

  if (isTestMode()) {
    // eslint-disable-next-line no-console
    console[logType](`[${deviceId}] ${message}`, {
      deviceId,
      deviceSerial,
      venueUuid,
      org,
      sessionId,
      activeOrderUuid,
      ...additionalData,
    })
  }
}

export default createDataDogLog
